/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * AutoGPT Agent Server
 * This server is used to execute agents that are created by the AutoGPT system.
 * OpenAPI spec version: 0.1
 */

export type PostV1CompleteOnboardingStepStep =
  (typeof PostV1CompleteOnboardingStepStep)[keyof typeof PostV1CompleteOnboardingStepStep];

export const PostV1CompleteOnboardingStepStep = {
  WELCOME: "WELCOME",
  USAGE_REASON: "USAGE_REASON",
  INTEGRATIONS: "INTEGRATIONS",
  AGENT_CHOICE: "AGENT_CHOICE",
  AGENT_NEW_RUN: "AGENT_NEW_RUN",
  AGENT_INPUT: "AGENT_INPUT",
  CONGRATS: "CONGRATS",
  ONBOARDING_COMPLETE: "ONBOARDING_COMPLETE",
  BUILDER_OPEN: "BUILDER_OPEN",
  CAPABILITY_CARDS: "CAPABILITY_CARDS",
  FIRST_RUN_TOUR: "FIRST_RUN_TOUR",
  CHATS_TIP: "CHATS_TIP",
  COST_TIP: "COST_TIP",
  EXPERT_TIP: "EXPERT_TIP",
  AGENTS_TAB_INTRO: "AGENTS_TAB_INTRO",
  MARKETPLACE_TAB_INTRO: "MARKETPLACE_TAB_INTRO",
  BUILD_TAB_INTRO: "BUILD_TAB_INTRO",
  WORKFLOWS_MOVED: "WORKFLOWS_MOVED",
} as const;
